import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from './settings.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { RacePlan } from '../race-plan/race-plan';
import { RacesService } from '../races/races.service';

@Component({
  selector: 'mc-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, OnDestroy {

  allDatabases: string[];

  canCommand: boolean = environment.isAdmin;

  readonly racePlans$: Observable<RacePlan[]> = this.racesService.racePlans$;

  constructor(
    private readonly settingsService: SettingsService,
    private readonly racesService: RacesService
  ) {
  }

  ngOnInit() {
    this.settingsService.listAllDbs().then(dbNames => this.allDatabases = dbNames);
  }

  ngOnDestroy() {
  }

  destroyAllSeasonDatabase() {
    this.settingsService.destroyAllSeasonDatabase();
  }

  compactRemoteDatabase() {
    this.settingsService.compactRemoteDatabase();
  }

  destroyAllLocalDatabases() {
    this.settingsService.destroyAllLocalDatabases();
  }

  broadcastClearCacheCommand() {
    this.settingsService.sendClearCacheCommand();
  }
}
